import {h, Fragment} from "preact"
import { SerpElement, useAppState } from "@nosto/preact";
import { productImagePlaceholder, formatCurrency } from "../helpers";
import { useState, useEffect, useMemo } from "preact/hooks";

export default function Product({ product }) {
  const { pageType } = useAppState();
  const [hovered, setHovered] = useState(false);
  const isCategory = pageType == "category";
  // const reviewCount = useMemo(() => product.customFields.find(field => field.key == "judgeme-badge")?.value, [])
  var productSlug = product.name.toLowerCase().split(" in ")?.[0];
  productSlug = productSlug.replaceAll(" ", "-");
  const [swatchData, setSwatchData] = useState();

  useEffect(() => {
    if(productSlug && product.name.includes(" in ")){
      fetch(`/search?type=product&q=title:${productSlug}&view=swatches`)
        .then((resp) => resp.text())
        .then((data) => {
          const parser = new DOMParser();
          const html = parser.parseFromString(data, 'text/html');
          const elems = html.querySelectorAll('a.swatch'); 
          
          const obj = [];
          elems.forEach((e) => {
            obj.push({
              title: e.getAttribute("data-swatch-title"),
              url: e.getAttribute("href"),
              img: e.querySelector("img")?.getAttribute("src")
            });
          });
          setSwatchData(obj);
        });

    }
  }, []);

  const alternateImageUrl =
    product?.alternateImageUrls != null &&
    product?.alternateImageUrls.length > 0
      ? product?.alternateImageUrls[0]
      : product.imageUrl;

  // const lowestPrice = product.skus.reduce((lowest, sku) => {
  //     return lowest === null || sku.price < lowest ? sku.price : lowest;
  // }, null);

  const inStockSkus = product.skus.filter((sku) => sku.availability === "InStock");

  const hasLowerPrice =
  inStockSkus.length > 1 &&
  inStockSkus.some((sku) => sku.price !== inStockSkus[0].price);

  let lowestPrice = null;
  if (hasLowerPrice) {
    lowestPrice = Math.min(...inStockSkus.map((sku) => sku.price));
  }

  const badges = [];
  product.tags1.forEach((tag) => {
    if (tag.includes("badge:")) {
      const matchWithBackgroundAndColor = tag.match(
        /badge: ([^@]+)@#([^*]+)\*#([^|]+)/
      );
      const matchWithTitle = tag.match(/badge: (.+)@#([^|]+)/);
      //console.log("tag", tag, "matchWithBackgroundAndColor", matchWithBackgroundAndColor, "matchWithTitle", matchWithTitle)
      if (matchWithBackgroundAndColor) {
        const badgeTitle = matchWithBackgroundAndColor[1]?.trim();
        const badgeBackground = `#${matchWithBackgroundAndColor[2].trim()}`;
        const badgeColor = `#${matchWithBackgroundAndColor[3].trim()}`;
        badges.push({
          title: badgeTitle,
          background: badgeBackground,
          color: badgeColor,
        });
      } else if (matchWithTitle) {
        const badgeTitle = matchWithTitle[1].trim();
        const badgeBackground = `#${matchWithTitle[2].trim()}`;
        badges.push({
          title: badgeTitle,
          background: badgeBackground,
          color: "#fff",
        });
      } else {
        var badgeTitle = tag?.split("badge:").pop().trim();
        badgeTitle = badgeTitle.split("| bottom")[0];
        badges.push({
          title: badgeTitle,
          background: "#acc7e7",
          color: "#fff",
        });
      }
    }
  });

  const nostoHandleUrl = product?.url.substring(
    product.url.lastIndexOf("/") + 1
  );

  return (
    <SerpElement
      as="li"
      hit={product}
      class="ns-product ns-border-box ns-text-undecorated ns-color-inherit nosto-product-info"
      x-nosto-handle={nostoHandleUrl}
    >
      <div class='frcp-wishlist-grid-btn-wrapper frcp-wishlist-grid-btn-wrapper--overlay-hover' 
          data-frcp-product-id={product.productId}
          data-frcp-product-handle={nostoHandleUrl}
          data-frcp-product-tags={JSON.stringify(product.tags1)}
      >
      </div>
      <div
        class="ns-image-wrap"
        // onMouseEnter={() => setHovered(true)}
        // onMouseLeave={() => setHovered(false)}
      >
        {/* <a  class="ns-d-block"> */}
          <div class="ns-image-outer ns-relative">
            <a class="ns-d-block" href={product.url}>
              <img class="ns-img-main" src={product.imageUrl} alt={product.name} />
            </a>
            <a class="ns-d-block" href={product.url}>
              <img class="ns-img-sec" src={alternateImageUrl} alt={product.name} />
            </a>
          </div>
          {/* {isCategory ?
           (<div class="ns-image" id={`nostoProductImage-${product.productId}`} style={{backgroundImage: `url(${hovered ? alternateImageUrl : product?.imageUrl})`}} alt={product.name}></div>)
          : (
            <img
              id={`nostoProductImage-${product.productId}`}
              src={hovered ? alternateImageUrl : product?.imageUrl}
              alt={product.name}
            />
          )} */}
        {/* </a> */}
      </div>

      <div class="ns-bottomBadges ns-bottom-badge-wrap">
        <div class="ns-card">
          {badges?.map((badge, index) => (
            <div
              class="ns-prodNameBadge ns-prodNameBadge--bottom ns-badge"
              style={{ backgroundColor: badge.background, color: badge.color }}
            >
              {badge.title}
            </div>
          ))}
        </div>
      </div>

      <div class="ns-brand-name-container" data-nosto-element="product">
        {/* {product.brand && <span class="kuBrandName ns-prod-brand">{product.brand}</span>} */} 
        <div class="kuName ns-prod-name">
          <a href={product.url} class="x-nosto-title">
            {product.name}
          </a>
        </div>
      </div>

      <div class="ns-price-container">
        {product.listPrice && product.listPrice > product.price ? (
          <div class="ns-price-container-special">
            <div class="ns-original-price nosto-oldprice"></div>
            <div class="ns-price ns-special-price nosto-newprice"></div> 
          </div>
        ) : (
          <div class="ns-price">
            {product.skus.length > 1 && hasLowerPrice && <>From </>}
            <span class="nosto-newprice">{/* {lowestPrice} */}</span>
            {/* <span>{product.skus.length > 1 && lowestPrice ? (<span>from {formatCurrency(lowestPrice)}</span>) : (<span>{formatCurrency(product.price)}</span> )}</span> */}
          </div>
        )}
      </div>
      {swatchData && swatchData.length > 1 && 
        <div class="ns-d-flex ns-swatches-wrap">
          {/* {swatchData?.map((swatch) => {
            return ( 
              <div 
                class="ns-swatch" 
                href={swatch.url} 
                style={`background-image: url('${swatch.img}'); ${product.name.includes("Jeans") || product.name.includes("Trousers") ? 'background-position: 40% center;' : ''}`}
                onClick={() => location.href = swatch.url}
              ></div> 
            )
          })} */}
          <div href={product.url} class="ns-d-block ns-swatch-count ns-prod-name">
            + {swatchData.length - 1} {swatchData.length - 1 == 1  ? 'colour' : 'colours'}
          </div>
        </div>
      }
      <div class="jdgm-badge-placeholder" data-handle={product.url.split("/").pop()}>
      {product.ratingValue !== null && product.ratingValue !== 0 && (
          <div class="ns-review-container">
            <span class="product-rating" data-rating={parseInt(product.ratingValue).toFixed(1)} aria-label={`Rated ${product.ratingValue} out of 5`}></span>
            <span class="ns-review-value">{product.reviewCount} {product.reviewCount == 1 ? 'review' : 'reviews'}</span>
          </div>
        )}
      </div>
    </SerpElement>
  );
}